import { gql } from "@apollo/client";

export const CREATE_PLAN_CUIDADO = gql`
mutation createPlanCuidado(
    $codigoSap: String!,
    $nombre: String!,
    $activo: Boolean!,
    $idTipoServicio: Int!,
    $esquema: Boolean!,
    $idUbicacion: Int!,
    $idFranjaEtaria: Int!,
    $idComplejidad: Int!,
    $idReporteVenta: Int!,
    $idTipoPlan: Int!,
    $topePediatrico: Decimal,
    $topeAdulto: Decimal,
    $profesionales: Boolean!,
    $tm: Boolean!,
    $envios: Boolean!,
    $cotizado: Boolean!,
    $observacion: String,
    $state: PlanCuidadoState!,
    $idTipoModulo: Int!,
    $complejidad: Boolean!,
    $volumenInicial: Int,
    $volumenFinal: Int,
    $idModoInfusion: Int
     ){
    createPlanCuidado(
        input: {
            codigoSap: $codigoSap,
            nombre: $nombre,
            activo: $activo,
            idTipoServicio: $idTipoServicio,
            esquema: $esquema,
            idUbicacion: $idUbicacion,
            idFranjaEtaria: $idFranjaEtaria,
            idComplejidad: $idComplejidad,
            idReporteVenta: $idReporteVenta,
            idTipoPlan: $idTipoPlan,                
            topePediatrico: $topePediatrico,
            topeAdulto: $topeAdulto,
            profesionales: $profesionales,
            tM: $tm,
            envios: $envios,                
            complejidad: $complejidad,
            observacion: $observacion,
            state: $state,
            idTipoModulo: $idTipoModulo,
            cotizado: $cotizado,
            volumenInicial: $volumenInicial,,
            volumenFinal: $volumenFinal,
            idModoInfusion: $idModoInfusion
        }
    ) {
        idPlanCuidado
    }
}
`;